import React, { useState, useEffect, useRef } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Dialog } from 'primereact/dialog';
import { InputText } from 'primereact/inputtext';
import { Dropdown } from 'primereact/dropdown';
import { Calendar } from 'primereact/calendar';
import { Toast } from 'primereact/toast';
import { Card } from 'primereact/card';
import { Button } from 'primereact/button';
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog';
import { Tag } from 'primereact/tag';
import { ProgressSpinner } from 'primereact/progressspinner';
import { FilterMatchMode } from 'primereact/api';
import moment from 'moment';
import { getSalesReactBaseUrl } from '../../utilities/api';
import '../CategoryMaster.css';

const API_URL = `${getSalesReactBaseUrl()}/api/server_masters`;
const SALES_API = `${getSalesReactBaseUrl()}/api/server_masters`;

const STATUS_OPTIONS = [
    { label: 'Active', value: 'Active' },
    { label: 'Inactive', value: 'Inactive' }
];

const ACCESS_OPTIONS = [
    { label: '0', value: 0 },
    { label: '1', value: 1 },
    { label: '2', value: 2 },
    { label: '3', value: 3 }
];

const STATUS_FIELD_MAP = {
    client_creation: 'status',
    branch_creation: 'branch_status',
    application_setting: 'setting_status',
    masters_creation: 'status',
    users: 'user_status',
    sms_authorize_final: 'status',
    tables: 'table_status'
};

const FIELD_VALIDATION_RULES = {
    client_creation: {
        client_name: { required: true, maxLength: 255, label: 'Client Name' },
        no_of_branches: { required: true, type: 'number', label: 'No Of Branches' },
        branch_prefix: { required: false, maxLength: 50, label: 'Branch Prefix' },
        status: { required: true, label: 'Status' },
        dayend_mailpdf: { required: false, type: 'number', label: 'Dayend State' },
        short_url: { required: false, maxLength: 500, type: 'url', label: 'Short URL' },
        report_url: { required: false, maxLength: 500, type: 'url', label: 'Report URL' },
        base_url: { required: true, maxLength: 500, type: 'url', label: 'Base URL' },
        server_url: { required: false, maxLength: 500, type: 'url', label: 'Server URL' }
    },
    branch_creation: {
        client_id: { required: true, label: 'Client' },
        branch_name: { required: true, maxLength: 255, label: 'Branch Name' },
        branch_title: { required: false, maxLength: 255, label: 'Branch Title' },
        branch_slno: { required: true, maxLength: 50, label: 'Branch Serial No' },
        invoice_prefix: { required: true, maxLength: 50, label: 'Invoice Prefix' },
        org_name: { required: false, maxLength: 255, label: 'Organization' },
        land_no: { required: false, maxLength: 20, type: 'mobile', label: 'Land Phone' },
        mobile: { required: false, maxLength: 15, type: 'mobile', label: 'Mobile No' },
        email_id: { required: false, maxLength: 255, type: 'email', label: 'Email' },
        gstin_no: { required: false, maxLength: 15, label: 'GSTIN' },
        address1: { required: true, maxLength: 500, label: 'Address 1' },
        address2: { required: false, maxLength: 500, label: 'Address 2' },
        website_name: { required: false, maxLength: 255, type: 'url', label: 'Website' },
        cin_no: { required: false, maxLength: 50, label: 'CIN Number' },
        pincode: { required: false, maxLength: 10, label: 'Pincode' },
        location: { required: false, maxLength: 255, label: 'Location' },
        social_order_percentage: { required: false, type: 'number', label: 'Social Order %' },
        branch_status: { required: true, label: 'Status' },
        effective_from: { required: true, type: 'date', label: 'Effective From' }
    },
    application_setting: {
        client_id: { required: true, label: 'Client' },
        branch_id: { required: true, label: 'Branch' },
        setting_name: { required: true, maxLength: 255, label: 'Setting Name' },
        setting_type: { required: true, maxLength: 100, label: 'Setting Type' },
        platform_id: { required: true, label: 'Platform' },
        setting_title: { required: true, maxLength: 255, label: 'Setting Title' },
        setting_access: { required: true, label: 'Setting Access' },
        effective_from: { required: true, type: 'date', label: 'Effective From' },
        setting_status: { required: true, label: 'Status' }
    },
    masters_creation: {
        client_id: { required: true, label: 'Client' },
        branch_id: { required: true, label: 'Branch' },
        master_id: { required: true, label: 'Master' },
        platform_id: { required: true, label: 'Platform' },
        master_type: { required: true, maxLength: 255, label: 'Master Name' },
        master_details: { required: true, maxLength: 255, label: 'Master Code' },
        master_image_path: { required: false, maxLength: 255, label: 'Master Image Path' },
        effective_from: { required: true, type: 'date', label: 'Effective From' },
        status: { required: true, label: 'Status' }
    },
    users: {
        client_id: { required: true, label: 'Client' },
        branch_id: { required: true, label: 'Branch' },
        username: { required: true, maxLength: 255, label: 'Username' },
        password: { required: true, minLength: 6, maxLength: 255, label: 'Password' },
        re_password: { required: false, type: 'confirm_password', label: 'Confirm Password' },
        mobile: { required: false, maxLength: 15, type: 'mobile', label: 'Mobile' },
        email_id: { required: false, maxLength: 255, type: 'email', label: 'Email' },
        platform_id: { required: true, label: 'Platform' },
        roleId: { required: true, label: 'Role' },
        user_status: { required: true, label: 'Status' },
        effective_from: { required: true, type: 'date', label: 'Effective From' }
    },
    sms_authorize_final: {
        client_id: { required: true, label: 'Client' },
        branch_id: { required: true, label: 'Branch' },
        message_type_id: { required: true, label: 'Message Type' },
        sender_id: { required: true, maxLength: 255, label: 'Sender ID' },
        enitity_id: { required: true, maxLength: 255, label: 'Entity ID' },
        api_key: { required: true, maxLength: 1000, label: 'API Key' },
        template_id: { required: true, maxLength: 255, label: 'Template ID' },
        user_id: { required: true, maxLength: 255, label: 'User ID' },
        mobile_no: { required: true, type: 'mobile', maxLength: 15, label: 'Mobile Number' },
        owner_num: { required: false, type: 'mobile', maxLength: 15, label: 'Owner Number' },
        branch_title: { required: false, maxLength: 255, label: 'Branch Title' },
        location: { required: false, maxLength: 255, label: 'Location' },
        email_id: { required: false, type: 'email', maxLength: 255, label: 'Email' },
        adminstrative_email: { required: false, type: 'email', maxLength: 255, label: 'Admin Email' },
        shorts_url: { required: false, type: 'url', label: 'Short URL' },
        mobileno_testing: { required: false, type: 'mobile', maxLength: 15, label: 'Testing Mobile No' },
        status: { required: true, label: 'Status' }
    },
    tables: {
        table_name: { required: true, maxLength: 255, label: 'Table Name' },
        seating_capacity: { required: true, type: 'number', label: 'Seating Capacity' },
        section_id: { required: true, label: 'Section' },
        supplier_id: { required: true, label: 'Supplier' },
        table_status: { required: true, label: 'Status' }
    }
};

const UNIQUE_FIELD_COMBINATIONS = {
    client_creation: [['client_name']],
    branch_creation: [['branch_name', 'client_id']],
    application_setting: [['setting_name', 'client_id', 'branch_id']],
    masters_creation: [['master_details', 'client_id', 'branch_id']],
    users: [['username', 'client_id', 'branch_id']],
    sms_authorize_final: [['sender_id', 'client_id', 'branch_id']],
    tables: [['table_name']]
};

const TABLE_CONFIGS = {
    client_creation: {
        pk: 'client_id',
        label: 'Clients',
        icon: 'pi pi-building',
        visibleCols: ['client_name', 'no_of_branches', 'branch_prefix', 'status', 'dayend_mailpdf', 'short_url'],
        formFields: [
            { key: 'client_name', label: 'Client Name', type: 'text', required: true },
            { key: 'no_of_branches', label: 'No Of Branches', type: 'text', required: true },
            { key: 'branch_prefix', label: 'Branch Prefix', type: 'text', required: false },
            { key: 'status', label: 'Status', type: 'status', required: true },
            { key: 'dayend_mailpdf', label: 'Dayend State', type: 'text', required: false },
            { key: 'short_url', label: 'Short URL', type: 'url', required: false },
            { key: 'report_url', label: 'Report URL', type: 'url', required: false },
            { key: 'base_url', label: 'Base URL', type: 'url', required: true },
            { key: 'server_url', label: 'Server URL', type: 'url', required: false }
        ],
        hasFilters: false
    },
    branch_creation: {
        pk: 'branch_id',
        label: 'Branches',
        icon: 'pi pi-map-marker',
        visibleCols: ['client_id', 'branch_name', 'branch_slno', 'invoice_prefix', 'mobile', 'gstin_no', 'branch_status', 'effective_from', 'data_transfer', 'config_status', 'config_date'],
        formFields: [
            { key: 'client_id', label: 'Client', type: 'client', required: true },
            { key: 'branch_name', label: 'Branch Name', type: 'text', required: true },
            { key: 'branch_title', label: 'Branch Title', type: 'text', required: false },
            { key: 'branch_slno', label: 'Branch Serial No', type: 'text', required: true },
            { key: 'invoice_prefix', label: 'Invoice Prefix', type: 'text', required: true },
            { key: 'org_name', label: 'Organization', type: 'text', required: false },
            { key: 'land_no', label: 'Land Phone', type: 'text', required: false },
            { key: 'mobile', label: 'Mobile No', type: 'text', required: false },
            { key: 'email_id', label: 'Email', type: 'email', required: false },
            { key: 'gstin_no', label: 'GSTIN', type: 'text', required: false },
            { key: 'address1', label: 'Address 1', type: 'text', required: true },
            { key: 'address2', label: 'Address 2', type: 'text', required: false },
            { key: 'website_name', label: 'Website', type: 'url', required: false },
            { key: 'cin_no', label: 'CIN Number', type: 'text', required: false },
            { key: 'pincode', label: 'Pincode', type: 'text', required: false },
            { key: 'location', label: 'Location', type: 'text', required: false },
            { key: 'social_order_percentage', label: 'Social Order %', type: 'text', required: false },
            { key: 'branch_status', label: 'Status', type: 'status', required: true },
            { key: 'effective_from', label: 'Effective From', type: 'date', required: true }
        ],
        hasFilters: true,
        filterFields: ['client']
    },
    application_setting: {
        pk: 'app_setting_id',
        label: 'Application Settings',
        icon: 'pi pi-cog',
        visibleCols: ['client_id', 'branch_id', 'setting_name', 'setting_type', 'setting_title', 'setting_access', 'setting_status', 'effective_from', 'data_transfer'],
        formFields: [
            { key: 'client_id', label: 'Client', type: 'client', required: true },
            { key: 'branch_id', label: 'Branch', type: 'branch', required: true },
            { key: 'setting_name', label: 'Setting Name', type: 'text', required: true },
            { key: 'setting_type', label: 'Setting Type', type: 'text', required: true },
            { key: 'platform_id', label: 'Platform', type: 'platform', required: true },
            { key: 'setting_title', label: 'Setting Title', type: 'text', required: true },
            { key: 'setting_access', label: 'Setting Access', type: 'access', required: true },
            { key: 'effective_from', label: 'Effective From', type: 'date', required: true },
            { key: 'setting_status', label: 'Status', type: 'status', required: true }
        ],
        hasFilters: true,
        filterFields: ['client', 'branch'],
        hasRowSelection: true,
        hasCellEdit: true
    },
    masters_creation: {
        pk: 'masterId',
        label: 'Masters Creation',
        icon: 'pi pi-database',
        visibleCols: ['client_id', 'branch_id', 'master_type', 'master_details', 'status', 'effective_from', 'data_transfer'],
        formFields: [
            { key: 'client_id', label: 'Client', type: 'client', required: true },
            { key: 'branch_id', label: 'Branch', type: 'branch', required: true },
            { key: 'master_id', label: 'Master', type: 'master', required: true },
            { key: 'platform_id', label: 'Platform', type: 'platform', required: true },
            { key: 'master_type', label: 'Master Name', type: 'text', required: true },
            { key: 'master_details', label: 'Master Code', type: 'text', required: true },
            { key: 'master_image_path', label: 'Master Image Path', type: 'text', required: false },
            { key: 'effective_from', label: 'Effective From', type: 'date', required: true },
            { key: 'status', label: 'Status', type: 'status', required: true }
        ],
        hasFilters: true,
        filterFields: ['client', 'branch'],
        hasRowSelection: true
    },
    users: {
        pk: 'userId',
        label: 'Users',
        icon: 'pi pi-users',
        visibleCols: ['client_id', 'branch_id', 'username', 'mobile', 'email_id', 'roleId', 'user_status', 'effective_from', 'data_transfer'],
        formFields: [
            { key: 'client_id', label: 'Client', type: 'client', required: true },
            { key: 'branch_id', label: 'Branch', type: 'branch', required: true },
            { key: 'platform_id', label: 'Platform', type: 'platform', required: true },
            { key: 'roleId', label: 'Role', type: 'role', required: true },
            { key: 'username', label: 'Username', type: 'text', required: true },
            { key: 'password', label: 'Password', type: 'password', required: true },
            { key: 're_password', label: 'Confirm Password', type: 'confirm_password', required: false },
            { key: 'mobile', label: 'Mobile', type: 'text', required: false },
            { key: 'email_id', label: 'Email', type: 'email', required: false },
            { key: 'user_status', label: 'Status', type: 'status', required: true },
            { key: 'effective_from', label: 'Effective From', type: 'date', required: true }
        ],
        hasFilters: true,
        filterFields: ['client', 'branch']
    },
    sms_authorize_final: {
        pk: 'auth_id',
        label: 'SMS Configuration',
        icon: 'pi pi-send',
        visibleCols: ['client_id', 'branch_id', 'message_type_id', 'sender_id', 'enitity_id', 'api_key', 'template_id', 'mobile_no', 'status'],
        formFields: [
            { key: 'client_id', label: 'Client', type: 'client', required: true },
            { key: 'branch_id', label: 'Branch', type: 'branch', required: true },
            { key: 'message_type_id', label: 'Message Type', type: 'message_type', required: true },
            { key: 'sender_id', label: 'Sender ID', type: 'text', required: true },
            { key: 'enitity_id', label: 'Entity ID', type: 'text', required: true },
            { key: 'api_key', label: 'API Key', type: 'text', required: true },
            { key: 'template_id', label: 'Template ID', type: 'text', required: true },
            { key: 'user_id', label: 'User ID', type: 'text', required: true },
            { key: 'mobile_no', label: 'Mobile Number', type: 'text', required: true },
            { key: 'owner_num', label: 'Owner Number', type: 'text', required: false },
            { key: 'branch_title', label: 'Branch Title', type: 'text', required: false },
            { key: 'location', label: 'Location', type: 'text', required: false },
            { key: 'email_id', label: 'Email', type: 'email', required: false },
            { key: 'adminstrative_email', label: 'Admin Email', type: 'email', required: false },
            { key: 'shorts_url', label: 'Short URL', type: 'url', required: false },
            { key: 'mobileno_testing', label: 'Testing Mobile No', type: 'text', required: false },
            { key: 'status', label: 'Status', type: 'status', required: true }
        ],
        hasFilters: true,
        filterFields: ['client', 'branch', 'message_type'],
        hasSmsTest: true
    },
    tables: {
        pk: 'table_id',
        label: 'Tables',
        icon: 'pi pi-table',
        visibleCols: ['table_name', 'seating_capacity', 'section_id', 'supplier_id', 'table_status'],
        formFields: [
            { key: 'table_name', label: 'Table Name', type: 'text', required: true },
            { key: 'seating_capacity', label: 'Seating Capacity', type: 'text', required: true },
            { key: 'section_id', label: 'Section', type: 'section', required: true },
            { key: 'supplier_id', label: 'Supplier', type: 'supplier', required: true },
            { key: 'table_status', label: 'Status', type: 'status', required: true }
        ],
        hasFilters: false
    }
};

const HEADER_MAP = {
    client_id: 'Client',
    branch_id: 'Branch',
    user_status: 'Status',
    branch_status: 'Status',
    master_status: 'Status',
    setting_status: 'Status',
    table_status: 'Status',
    effective_from: 'Effective From',
    branch_name: 'Branch Name',
    branch_title: 'Branch Title',
    branch_slno: 'Sl No.',
    invoice_prefix: 'Invoice Prefix',
    org_name: 'Organization',
    land_no: 'Land Phone',
    email_id: 'Email',
    gstin_no: 'GSTIN',
    address1: 'Address 1',
    address2: 'Address 2',
    website_name: 'Website',
    cin_no: 'CIN Number',
    pincode: 'Pincode',
    location: 'Location',
    social_order_percentage: 'Social Order %',
    config_status: 'Config Status',
    config_date: 'Config Date',
    client_name: 'Client Name',
    no_of_branches: 'No Of Branches',
    branch_prefix: 'Branch Prefix',
    dayend_mailpdf: 'Dayend State',
    short_url: 'Short URL',
    report_url: 'Report URL',
    base_url: 'Base URL',
    server_url: 'Server URL',
    roleId: 'Role',
    re_password: 'Confirm Password',
    platform_id: 'Platform',
    setting_name: 'Setting Name',
    setting_type: 'Setting Type',
    setting_title: 'Setting Title',
    setting_access: 'Setting Access',
    master_type: 'Master Name',
    master_details: 'Master Code',
    master_image_path: 'Master Image Path',
    message_type_id: 'Message Type',
    sender_id: 'Sender ID',
    enitity_id: 'Entity ID',
    api_key: 'API Key',
    template_id: 'Template ID',
    user_id: 'User ID',
    mobile: 'Mobile',
    mobile_no: 'Mobile',
    owner_num: 'Owner Number',
    adminstrative_email: 'Admin Email',
    shorts_url: 'Short URL',
    mobileno_testing: 'Testing Mobile No',
    table_name: 'Table Name',
    seating_capacity: 'Seating Capacity',
    section_id: 'Section',
    supplier_id: 'Supplier',
    data_transfer: 'Data Transfer'
};

const colHeader = (key) => HEADER_MAP[key] || key.replace(/_/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase());

const CELL_EDITABLE_KEYS = ['setting_name', 'setting_type', 'setting_title', 'setting_status'];

const Submasters = () => {
    const [active, setActive] = useState('client_creation');
    const [data, setData] = useState([]);
    const [filteredData, setFilteredData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [statusFilter, setStatusFilter] = useState(null);
    const [filters, setFilters] = useState({ global: { value: null, matchMode: FilterMatchMode.CONTAINS } });
    const [globalFilterValue, setGlobalFilterValue] = useState('');

    const [clients, setClients] = useState([]);
    const [allBranches, setAllBranches] = useState([]);
    const [roles, setRoles] = useState([]);
    const [sections, setSections] = useState([]);
    const [suppliers, setSuppliers] = useState([]);
    const [messageTypes, setMessageTypes] = useState([]);
    const [platforms, setPlatforms] = useState([]);
    const [masterList, setMasterList] = useState([]);

    const [filterClient, setFilterClient] = useState(null);
    const [filterBranch, setFilterBranch] = useState(null);
    const [filterMessageType, setFilterMessageType] = useState(null);
    const [filterBranches, setFilterBranches] = useState([]);

    const [visible, setVisible] = useState(false);
    const [isEditing, setIsEditing] = useState(false);
    const [formData, setFormData] = useState({});
    const [errors, setErrors] = useState({});
    const [formBranches, setFormBranches] = useState([]);

    // Bulk selection / status
    const [selectedRows, setSelectedRows] = useState([]);
    const [bulkStatusDialog, setBulkStatusDialog] = useState(false);
    const [bulkStatusValue, setBulkStatusValue] = useState(null);
    const [bulkStatusEff, setBulkStatusEff] = useState(new Date());
    const [bulkAccessDialog, setBulkAccessDialog] = useState(false);
    const [bulkAccessValue, setBulkAccessValue] = useState(null);
    const [bulkAccessEff, setBulkAccessEff] = useState(new Date());

    // App-settings inline cell editing
    const [editedRows, setEditedRows] = useState([]);

    // SMS test
    const [smsTestDialog, setSmsTestDialog] = useState(false);
    const [smsTestForm, setSmsTestForm] = useState({ auth_id: null, mobile: '' });
    const [smsTestLoading, setSmsTestLoading] = useState(false);

    const toast = useRef(null);
    const provisionAttemptedRef = useRef(null);
    const cfg = TABLE_CONFIGS[active];
    const tables = Object.entries(TABLE_CONFIGS).map(([value, c]) => ({ value, ...c }));

    const statusField = STATUS_FIELD_MAP[active];
    const baseFilteredData = (() => {
        let result = [...data];
        if (cfg.hasFilters) {
            if (filterClient && cfg.filterFields.includes('client')) result = result.filter((r) => String(r.client_id) === String(filterClient));
            if (filterBranch && cfg.filterFields.includes('branch')) result = result.filter((r) => String(r.branch_id) === String(filterBranch));
            if (filterMessageType && cfg.filterFields.includes('message_type')) result = result.filter((r) => String(r.message_type_id) === String(filterMessageType));
        }
        return result;
    })();
    const activeCount = statusField ? baseFilteredData.filter((r) => r[statusField] === 'Active').length : 0;
    const inactiveCount = statusField ? baseFilteredData.filter((r) => r[statusField] === 'Inactive').length : 0;

    useEffect(() => {
        const loadLookups = async () => {
            try {
                const [clientRows, branchRows, roleRes, sectionRows, supplierRows, messageTypeRows, platformRows, masterRows] = await Promise.all([
                    fetch(`${API_URL}/list/client_creation`).then((r) => r.json()),
                    fetch(`${API_URL}/list/branch_creation`).then((r) => r.json()),
                    fetch(`${SALES_API}/list/roles`).then((r) => r.json()),
                    fetch(`${API_URL}/list/sections`).then((r) => r.json()),
                    fetch(`${API_URL}/list/supplier`).then((r) => r.json()),
                    fetch(`${API_URL}/list/message_type`).then((r) => r.json()),
                    fetch(`${API_URL}/list/platform`).then((r) => r.json()),
                    fetch(`${API_URL}/list/master`).then((r) => r.json())
                ]);
                if (Array.isArray(clientRows)) setClients(clientRows.map((c) => ({ label: c.client_name, value: String(c.client_id) })));
                if (Array.isArray(branchRows)) setAllBranches(branchRows.map((b) => ({ label: b.branch_name, value: String(b.branch_id), clientId: String(b.client_id) })));
                if (Array.isArray(roleRes)) setRoles(roleRes.map((r) => ({ label: r.role, value: String(r.roleId) })));
                if (Array.isArray(sectionRows)) setSections(sectionRows.map((s) => ({ label: s.section_name, value: String(s.sectionId) })));
                if (Array.isArray(supplierRows)) setSuppliers(supplierRows.map((s) => ({ label: s.supplier_name, value: String(s.supplier_id) })));
                if (Array.isArray(messageTypeRows)) setMessageTypes(messageTypeRows.map((m) => ({ label: m.message_type_name, value: String(m.message_type_id) })));
                if (Array.isArray(platformRows)) setPlatforms(platformRows.map((p) => ({ label: p.platform_name, value: String(p.platform_id) })));
                if (Array.isArray(masterRows)) setMasterList(masterRows.map((m) => ({ label: `${m.master_type} — ${m.master_details}`, value: String(m.master_id) })));
            } catch (error) {
                console.error('Error loading lookups:', error);
            }
        };
        loadLookups();
    }, []);

    useEffect(() => {
        setData([]);
        setFilteredData([]);
        setGlobalFilterValue('');
        setStatusFilter(null);
        setFilterClient(null);
        setFilterBranch(null);
        setFilterMessageType(null);
        setFilterBranches([]);
        setFilters({ global: { value: null, matchMode: FilterMatchMode.CONTAINS } });
        setSelectedRows([]);
        setEditedRows([]);
        loadData(active);
    }, [active]);

    useEffect(() => {
        applyFilters();
    }, [data, statusFilter, filterClient, filterBranch, filterMessageType]);

    useEffect(() => {
        if (active === 'application_setting') {
            setEditedRows(filteredData.map((r) => ({ ...r })));
        }
    }, [filteredData, active]);

    // Once both Client + Branch are picked on Application Settings, make sure every
    // active `setting` master entry has a row for this branch — a branch that has
    // never been configured would otherwise just show an empty table. Idempotent:
    // the backend only fills in setting_name gaps, so this is safe to fire on every
    // reload, and provisionAttemptedRef stops it from re-hitting the same combo
    // repeatedly when the catalog itself has nothing left to provision.
    useEffect(() => {
        if (active !== 'application_setting' || !filterClient || !filterBranch) return;
        const key = `${filterClient}:${filterBranch}`;
        const hasAny = data.some((r) => String(r.client_id) === String(filterClient) && String(r.branch_id) === String(filterBranch));
        if (hasAny || provisionAttemptedRef.current === key) return;
        provisionAttemptedRef.current = key;
        (async () => {
            try {
                const res = await fetch(`${API_URL}/provision_application_settings`, {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ client_id: filterClient, branch_id: filterBranch })
                });
                const result = await res.json();
                if (result?.inserted) {
                    toast.current?.show({ severity: 'success', summary: 'Settings Provisioned', detail: result.message });
                    loadData(active);
                }
            } catch {
                toast.current?.show({ severity: 'error', summary: 'Error', detail: 'Could not auto-provision application settings for this branch' });
            }
        })();
    }, [active, filterClient, filterBranch, data]);

    useEffect(() => {
        if (filterClient) {
            const branches = allBranches.filter((b) => b.clientId === String(filterClient));
            setFilterBranches(branches);
            if (filterBranch && !branches.some((b) => b.value === filterBranch)) setFilterBranch(null);
        } else {
            setFilterBranches([]);
            setFilterBranch(null);
        }
    }, [filterClient, allBranches]);

    const loadData = async (table) => {
        setLoading(true);
        try {
            const res = await fetch(`${API_URL}/list/${table}`);
            const json = await res.json();
            setData(Array.isArray(json) ? json : []);
        } catch (error) {
            console.error('Error loading data:', error);
            toast.current?.show({ severity: 'error', summary: 'Error', detail: `Could not load ${table}` });
            setData([]);
        } finally {
            setLoading(false);
        }
    };

    const applyFilters = () => {
        let result = [...data];
        if (statusFilter && statusField) result = result.filter((item) => item[statusField] === statusFilter);
        if (cfg.hasFilters) {
            if (filterClient && cfg.filterFields.includes('client')) result = result.filter((item) => String(item.client_id) === String(filterClient));
            if (filterBranch && cfg.filterFields.includes('branch')) result = result.filter((item) => String(item.branch_id) === String(filterBranch));
            if (filterMessageType && cfg.filterFields.includes('message_type')) result = result.filter((item) => String(item.message_type_id) === String(filterMessageType));
        }
        setFilteredData(result);
    };

    const branchesByClient = (clientId) => allBranches.filter((b) => b.clientId === String(clientId));
    const fmtDate = (d) => (moment(d).isValid() ? moment(d).format('DD-MM-YYYY') : d || '');
    const getClientName = (id) => clients.find((c) => String(c.value) === String(id))?.label || id;
    const getBranchName = (id) => allBranches.find((b) => String(b.value) === String(id))?.label || id;
    const getRoleName = (id) => roles.find((r) => String(r.value) === String(id))?.label || id;
    const getSectionName = (id) => sections.find((s) => String(s.value) === String(id))?.label || id;
    const getSupplierName = (id) => suppliers.find((s) => String(s.value) === String(id))?.label || id;
    const getMessageTypeName = (id) => messageTypes.find((m) => String(m.value) === String(id))?.label || id;
    const getPlatformName = (id) => platforms.find((p) => String(p.value) === String(id))?.label || id;

    const validateForm = (fields, fd) => {
        const validationRules = FIELD_VALIDATION_RULES[active] || {};
        const newErrors = {};
        fields.forEach((f) => {
            const rule = validationRules[f.key];
            if (!rule) return;
            const value = fd[f.key];
            // 0 is a legitimate value for numeric/select fields (e.g. Setting Access) —
            // only null/undefined/empty-string count as "not filled in".
            const isEmpty = value === null || value === undefined || (typeof value === 'string' && !value.trim());
            // Confirm-password cross-field validation
            if (rule.type === 'confirm_password') {
                if (fd.password && isEmpty) {
                    newErrors[f.key] = 'Please confirm your password';
                } else if (fd.password && value !== fd.password) {
                    newErrors[f.key] = 'Passwords do not match';
                }
                return;
            }
            if (rule.required && isEmpty) {
                newErrors[f.key] = `${rule.label} is required`;
                return;
            }
            if (isEmpty) return;
            if (rule.maxLength && typeof value === 'string' && value.length > rule.maxLength) newErrors[f.key] = `${rule.label} must not exceed ${rule.maxLength} characters`;
            if (rule.minLength && typeof value === 'string' && value.length < rule.minLength) newErrors[f.key] = `${rule.label} must be at least ${rule.minLength} characters`;
            if (rule.type === 'number' && isNaN(parseFloat(value))) newErrors[f.key] = `${rule.label} must be a valid number`;
            if (rule.type === 'url' && value) {
                try {
                    new URL(value);
                } catch {
                    newErrors[f.key] = `${rule.label} must be a valid URL`;
                }
            }
            if (rule.type === 'mobile' && value && !/^[0-9]{10,15}$/.test(value.replace(/[\s\-\+]/g, ''))) newErrors[f.key] = `${rule.label} must be a valid phone number`;
            if (rule.type === 'email' && value && !/\S+@\S+\.\S+/.test(value)) newErrors[f.key] = `${rule.label} must be a valid email address`;
        });
        return newErrors;
    };

    const checkDuplicates = (fd) => {
        const uniqueCombinations = UNIQUE_FIELD_COMBINATIONS[active] || [];
        for (const fieldCombination of uniqueCombinations) {
            const values = fieldCombination.map((field) => fd[field]);
            if (values.some((v) => !v || (typeof v === 'string' && !v.trim()))) continue;
            const isDuplicate = data.some((row) => {
                if (isEditing && fd[cfg.pk] && String(row[cfg.pk]) === String(fd[cfg.pk])) return false;
                return fieldCombination.every(
                    (field, index) =>
                        String(row[field] || '')
                            .toLowerCase()
                            .trim() ===
                        String(values[index] || '')
                            .toLowerCase()
                            .trim()
                );
            });
            if (isDuplicate) {
                const fieldLabels = fieldCombination.map((f) => FIELD_VALIDATION_RULES[active]?.[f]?.label || f).join(' + ');
                toast.current?.show({ severity: 'warn', summary: 'Duplicate Record', detail: `A record with this ${fieldLabels} combination already exists`, life: 5000 });
                return false;
            }
        }
        return true;
    };

    const saveItem = async () => {
        const payload = { ...formData };
        if (!isEditing) delete payload[cfg.pk];
        delete payload.re_password;
        if (payload.effective_from instanceof Date) payload.effective_from = moment(payload.effective_from).format('YYYY-MM-DD');
        try {
            const res = await fetch(`${API_URL}/save/${active}`, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(payload) });
            const json = await res.json();
            if (json.status === 'success') {
                toast.current?.show({ severity: 'success', summary: isEditing ? 'Updated' : 'Saved', detail: isEditing ? 'Record updated successfully' : 'Record created successfully' });
                setVisible(false);
                setFormData({});
                setErrors({});
                loadData(active);
            } else {
                toast.current?.show({ severity: 'error', summary: 'Error', detail: json.message || 'Operation failed' });
            }
        } catch {
            toast.current?.show({ severity: 'error', summary: 'Network Error', detail: 'Could not reach the server' });
        }
    };

    // Bulk status change for application_setting and masters_creation
    const handleBulkStatusChange = async () => {
        if (!selectedRows.length || !bulkStatusValue || !bulkStatusEff) return;
        try {
            const effective_from = moment(bulkStatusEff).format('YYYY-MM-DD');
            await Promise.all(
                selectedRows.map((row) => {
                    const payload = { ...row, [statusField]: bulkStatusValue, effective_from, data_transfer: 'pending' };
                    return fetch(`${API_URL}/save/${active}`, {
                        method: 'POST',
                        headers: { 'Content-Type': 'application/json' },
                        body: JSON.stringify(payload)
                    });
                })
            );
            toast.current?.show({ severity: 'success', summary: 'Updated', detail: `${selectedRows.length} record(s) set to ${bulkStatusValue}` });
            setBulkStatusDialog(false);
            setSelectedRows([]);
            setBulkStatusValue(null);
            setBulkStatusEff(new Date());
            loadData(active);
        } catch {
            toast.current?.show({ severity: 'error', summary: 'Network Error', detail: 'Could not reach the server' });
        }
    };

    // Bulk Setting Access change for application_setting
    const handleBulkAccessChange = async () => {
        if (!selectedRows.length || bulkAccessValue === null || bulkAccessValue === undefined || !bulkAccessEff) return;
        try {
            const effective_from = moment(bulkAccessEff).format('YYYY-MM-DD');
            await Promise.all(
                selectedRows.map((row) => {
                    const payload = { ...row, setting_access: bulkAccessValue, effective_from, data_transfer: 'pending' };
                    return fetch(`${API_URL}/save/${active}`, {
                        method: 'POST',
                        headers: { 'Content-Type': 'application/json' },
                        body: JSON.stringify(payload)
                    });
                })
            );
            toast.current?.show({ severity: 'success', summary: 'Updated', detail: `${selectedRows.length} record(s) set to access ${bulkAccessValue}` });
            setBulkAccessDialog(false);
            setSelectedRows([]);
            setBulkAccessValue(null);
            setBulkAccessEff(new Date());
            loadData(active);
        } catch {
            toast.current?.show({ severity: 'error', summary: 'Network Error', detail: 'Could not reach the server' });
        }
    };

    // Inline cell editing save for application_setting
    const handleSaveAllSettings = async () => {
        const changes = editedRows.filter((row, idx) => JSON.stringify(row) !== JSON.stringify(filteredData[idx]));
        if (!changes.length) {
            toast.current?.show({ severity: 'info', summary: 'No Changes', detail: 'Nothing to update' });
            return;
        }
        try {
            await Promise.all(
                changes.map((row) =>
                    fetch(`${SALES_API}/save/application_setting`, {
                        method: 'POST',
                        headers: { 'Content-Type': 'application/json' },
                        body: JSON.stringify({
                            id: row.app_setting_id,
                            settingName: row.setting_name,
                            settingAccess: row.setting_access,
                            settingType: row.setting_type,
                            settingTitle: row.setting_title,
                            settingStatus: row.setting_status,
                            effectiveFrom: row.effective_from instanceof Date ? moment(row.effective_from).format('YYYY-MM-DD') : row.effective_from
                        })
                    })
                )
            );
            toast.current?.show({ severity: 'success', summary: 'Saved', detail: `${changes.length} setting(s) updated` });
            loadData(active);
        } catch {
            toast.current?.show({ severity: 'error', summary: 'Error', detail: 'Failed to save changes' });
        }
    };

    const onCellEditComplete = (e) => {
        const { rowIndex, field, newValue } = e;
        const updated = [...editedRows];
        updated[rowIndex] = { ...updated[rowIndex], [field]: newValue };
        setEditedRows(updated);
    };

    const cellEditor = (key, options) => {
        if (key === 'setting_status') return <Dropdown value={options.value} options={STATUS_OPTIONS} onChange={(e) => options.editorCallback(e.value)} placeholder="Select status" className="w-full" />;
        if (key === 'setting_access') return <Dropdown value={options.value !== undefined ? options.value : ''} options={ACCESS_OPTIONS} onChange={(e) => options.editorCallback(e.value)} placeholder="Access" className="w-full" />;
        return <InputText value={options.value || ''} onChange={(e) => options.editorCallback(e.target.value)} className="w-full" />;
    };

    // SMS test
    const openSmsTest = (row) => {
        setSmsTestForm({ auth_id: row.auth_id, mobile: '' });
        setSmsTestDialog(true);
    };

    const handleSmsTest = async () => {
        if (!smsTestForm.mobile.trim()) {
            toast.current?.show({ severity: 'warn', summary: 'Required', detail: 'Enter a mobile number to test' });
            return;
        }
        setSmsTestLoading(true);
        try {
            const res = await fetch(`${SALES_API}/send_sms_test`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ auth_id: smsTestForm.auth_id, mobile: smsTestForm.mobile })
            });
            const json = await res.json();
            if (json.status === 'success') {
                toast.current?.show({ severity: 'success', summary: 'SMS Sent', detail: 'Test SMS sent successfully' });
                setSmsTestDialog(false);
            } else {
                toast.current?.show({ severity: 'error', summary: 'Failed', detail: json.message || 'Failed to send test SMS' });
            }
        } catch {
            toast.current?.show({ severity: 'error', summary: 'Error', detail: 'Could not reach the server' });
        } finally {
            setSmsTestLoading(false);
        }
    };

    const handleResetFilters = () => {
        setGlobalFilterValue('');
        setStatusFilter(null);
        setFilterClient(null);
        setFilterBranch(null);
        setFilterMessageType(null);
        setFilters({ global: { value: null, matchMode: FilterMatchMode.CONTAINS } });
    };

    const openAdd = () => {
        setIsEditing(false);
        setFormData({ effective_from: new Date() });
        setFormBranches([]);
        setErrors({});
        setVisible(true);
    };

    const openEdit = (row) => {
        setIsEditing(true);
        const fd = { ...row };
        if (fd.effective_from) fd.effective_from = moment(fd.effective_from, ['YYYY-MM-DD', 'DD-MM-YYYY']).toDate();
        ['client_id', 'branch_id', 'roleId', 'section_id', 'supplier_id', 'message_type_id', 'platform_id', 'master_id'].forEach((k) => {
            if (fd[k] !== undefined) fd[k] = String(fd[k]);
        });
        // ACCESS_OPTIONS uses numeric values (0/1/2/3) — the API can return this as a
        // numeric string, which would fail the Dropdown's strict-equality match and
        // show no selection even though the row has a value.
        if (fd.setting_access !== undefined && fd.setting_access !== null) fd.setting_access = Number(fd.setting_access);
        setFormData(fd);
        setErrors({});
        if (fd.client_id) setFormBranches(branchesByClient(fd.client_id));
        setVisible(true);
    };

    const onFormClientChange = (clientId) => {
        setFormData((prev) => ({ ...prev, client_id: clientId, branch_id: '' }));
        setFormBranches(clientId ? branchesByClient(clientId) : []);
    };

    const renderCell = (key, row) => {
        const val = row[key];
        if (['status', 'user_status', 'branch_status', 'master_status', 'setting_status', 'table_status'].includes(key))
            return <Tag value={val} severity={val === 'Active' ? 'success' : 'danger'} rounded style={{ minWidth: '70px', textAlign: 'center' }} />;
        if (key === 'client_id') return getClientName(val);
        if (key === 'branch_id') return getBranchName(val);
        if (key === 'roleId') return getRoleName(val);
        if (key === 'section_id') return getSectionName(val);
        if (key === 'supplier_id') return getSupplierName(val);
        if (key === 'message_type_id') return getMessageTypeName(val);
        if (key === 'platform_id') return getPlatformName(val);
        if (key === 'effective_from' || key === 'config_date') return fmtDate(val);
        if (key === 'data_transfer') {
            if (!val) return '—';
            const isUpdated = String(val).toLowerCase() === 'updated';
            return <Tag value={val} severity={isUpdated ? 'success' : 'warning'} rounded style={{ minWidth: '70px', textAlign: 'center' }} />;
        }
        return val ?? '—';
    };

    const confirmSave = () => {
        const errs = validateForm(cfg.formFields, formData);
        if (Object.keys(errs).length) {
            setErrors(errs);
            toast.current?.show({ severity: 'error', summary: 'Validation Error', detail: 'Please fix the highlighted fields' });
            return;
        }
        if (!checkDuplicates(formData)) return;
        confirmDialog({
            message: isEditing ? `Are you sure you want to update this ${cfg.label}?` : `Are you sure you want to add this new ${cfg.label}?`,
            header: 'Confirm',
            icon: 'pi pi-exclamation-triangle',
            acceptLabel: 'Yes, Proceed',
            rejectLabel: 'Cancel',
            acceptClassName: 'p-button-success',
            rejectClassName: 'p-button-text',
            accept: () => saveItem()
        });
    };

    const renderField = (f, fd, setFd, errs) => {
        const val = fd[f.key];
        const err = errs[f.key];
        const cls = err ? 'p-invalid' : '';
        const input = () => {
            switch (f.type) {
                case 'status':
                    return <Dropdown value={val} options={STATUS_OPTIONS} onChange={(e) => setFd((p) => ({ ...p, [f.key]: e.value }))} placeholder="Select status" className={`w-full ${cls}`} />;
                case 'access':
                    return <Dropdown value={val !== undefined ? val : ''} options={ACCESS_OPTIONS} onChange={(e) => setFd((p) => ({ ...p, [f.key]: e.value }))} placeholder="Select access" className={`w-full ${cls}`} />;
                case 'client':
                    return <Dropdown value={val} options={clients} onChange={(e) => onFormClientChange(e.value)} placeholder="Select Client" className={`w-full ${cls}`} filter />;
                case 'branch':
                    return (
                        <Dropdown
                            value={val}
                            options={formBranches}
                            onChange={(e) => setFd((p) => ({ ...p, [f.key]: e.value }))}
                            placeholder={formBranches.length ? 'Select Branch' : 'Select Client first'}
                            className={`w-full ${cls}`}
                            disabled={!fd.client_id}
                            filter
                        />
                    );
                case 'role':
                    return <Dropdown value={val} options={roles} onChange={(e) => setFd((p) => ({ ...p, [f.key]: e.value }))} placeholder="Select Role" className={`w-full ${cls}`} />;
                case 'section':
                    return <Dropdown value={val} options={sections} onChange={(e) => setFd((p) => ({ ...p, [f.key]: e.value }))} placeholder="Select Section" className={`w-full ${cls}`} filter />;
                case 'supplier':
                    return <Dropdown value={val} options={suppliers} onChange={(e) => setFd((p) => ({ ...p, [f.key]: e.value }))} placeholder="Select Supplier" className={`w-full ${cls}`} filter />;
                case 'message_type':
                    return <Dropdown value={val} options={messageTypes} onChange={(e) => setFd((p) => ({ ...p, [f.key]: e.value }))} placeholder="Select Message Type" className={`w-full ${cls}`} filter />;
                case 'date':
                    return <Calendar value={val instanceof Date ? val : null} onChange={(e) => setFd((p) => ({ ...p, [f.key]: e.value }))} dateFormat="dd-mm-yy" placeholder="DD-MM-YYYY" className={`w-full ${cls}`} showIcon />;
                case 'password':
                    return <InputText type="password" value={val || ''} onChange={(e) => setFd((p) => ({ ...p, [f.key]: e.target.value }))} className={`w-full ${cls}`} />;
                case 'confirm_password':
                    return <InputText type="password" value={val || ''} onChange={(e) => setFd((p) => ({ ...p, [f.key]: e.target.value }))} className={`w-full ${cls}`} />;
                case 'email':
                    return <InputText type="email" value={val || ''} onChange={(e) => setFd((p) => ({ ...p, [f.key]: e.target.value }))} className={`w-full ${cls}`} />;
                case 'url':
                    return <InputText type="url" value={val || ''} onChange={(e) => setFd((p) => ({ ...p, [f.key]: e.target.value }))} className={`w-full ${cls}`} />;
                case 'platform':
                    return <Dropdown value={val} options={platforms} onChange={(e) => setFd((p) => ({ ...p, [f.key]: e.value }))} placeholder="Select Platform" className={`w-full ${cls}`} filter />;
                case 'master':
                    return <Dropdown value={val} options={masterList} onChange={(e) => setFd((p) => ({ ...p, [f.key]: e.value }))} placeholder="Select Master" className={`w-full ${cls}`} filter />;
                default:
                    return <InputText value={val || ''} onChange={(e) => setFd((p) => ({ ...p, [f.key]: e.target.value }))} className={`w-full ${cls}`} />;
            }
        };
        return (
            <div className="field-group" key={f.key}>
                <label className="field-label">
                    {f.label}
                    {f.required && <span className="required-mark"> *</span>}
                </label>
                {input()}
                {err && (
                    <small className="error-message">
                        <i className="pi pi-exclamation-circle"></i> {err}
                    </small>
                )}
            </div>
        );
    };

    const actionBodyTemplate = (rd) => (
        <div className="flex gap-1 justify-content-center">
            <Button icon="pi pi-pencil" rounded text className="p-button-warning" onClick={() => openEdit(rd)} tooltip="Edit" tooltipOptions={{ position: 'top' }} />
            {cfg.hasSmsTest && <Button icon="pi pi-send" rounded text className="p-button-info" onClick={() => openSmsTest(rd)} tooltip="Test SMS" tooltipOptions={{ position: 'top' }} />}
        </div>
    );

    const hasAppSettingChanges = active === 'application_setting' && editedRows.some((row, idx) => JSON.stringify(row) !== JSON.stringify(filteredData[idx]));

    const isSmsModule = active === 'sms_authorize_final';
    const dialogWidth = isSmsModule ? '750px' : '500px';

    return (
        <>
            <Toast ref={toast} />
            <ConfirmDialog />

            <div className="mb-4">
                <h2 className="text-3xl font-bold mb-2" style={{ color: 'var(--primary-color)' }}>
                    Sub Masters
                </h2>
                <p className="text-color-secondary">View and manage sub master records</p>
            </div>

            <Card className="mb-4 bill-reports-filter-card">
                <div className="flex flex-wrap gap-4 align-items-end bill-reports-filter-row">
                    <div className="flex flex-column" style={{ flex: '1 1 200px', minWidth: '200px' }}>
                        <label htmlFor="module" className="mb-2 font-medium text-sm">
                            Module
                        </label>
                        <Dropdown id="module" value={active} options={tables} onChange={(e) => setActive(e.value)} optionLabel="label" optionValue="value" placeholder="Select Module" className="w-full" />
                    </div>
                    {cfg.hasFilters && cfg.filterFields.includes('client') && (
                        <div className="flex flex-column" style={{ flex: '1 1 200px', minWidth: '200px' }}>
                            <label className="mb-2 font-medium text-sm">Client</label>
                            <Dropdown value={filterClient} options={clients} onChange={(e) => setFilterClient(e.value)} placeholder="Filter by Client" className="w-full" filter showClear />
                        </div>
                    )}
                    {cfg.hasFilters && cfg.filterFields.includes('branch') && (
                        <div className="flex flex-column" style={{ flex: '1 1 200px', minWidth: '200px' }}>
                            <label className="mb-2 font-medium text-sm">Branch</label>
                            <Dropdown
                                value={filterBranch}
                                options={filterBranches}
                                onChange={(e) => setFilterBranch(e.value)}
                                placeholder={filterClient ? 'Filter by Branch' : 'Select Client First'}
                                className="w-full"
                                filter
                                showClear
                                disabled={!filterClient}
                            />
                        </div>
                    )}
                    {cfg.hasFilters && cfg.filterFields.includes('message_type') && (
                        <div className="flex flex-column" style={{ flex: '1 1 200px', minWidth: '200px' }}>
                            <label className="mb-2 font-medium text-sm">Message Type</label>
                            <Dropdown value={filterMessageType} options={messageTypes} onChange={(e) => setFilterMessageType(e.value)} placeholder="Filter by Message Type" className="w-full" filter showClear />
                        </div>
                    )}
                    <div className="flex gap-2" style={{ flex: '0 0 auto' }}>
                        <Button label="Reset" icon="pi pi-refresh" className="p-button-secondary" onClick={handleResetFilters} />
                    </div>
                </div>
            </Card>

            <Card className="bill-reports-container">
                <div className="flex flex-wrap justify-content-between align-items-center mb-4 gap-3">
                    <div className="flex align-items-center gap-2 flex-wrap">
                        <h3 className="text-xl font-semibold m-0">{cfg.label} List</h3>
                        <div className="category-status-tabs">
                            <button className={`status-tab-btn active-tab${statusFilter === 'Active' ? ' selected' : ''}`} onClick={() => setStatusFilter(statusFilter === 'Active' ? null : 'Active')}>
                                <i className="pi pi-check-circle" /> Active <span className="tab-count">{activeCount}</span>
                            </button>
                            <button className={`status-tab-btn inactive-tab${statusFilter === 'Inactive' ? ' selected' : ''}`} onClick={() => setStatusFilter(statusFilter === 'Inactive' ? null : 'Inactive')}>
                                <i className="pi pi-times-circle" /> Inactive <span className="tab-count">{inactiveCount}</span>
                            </button>
                        </div>
                        {cfg.hasRowSelection && selectedRows.length > 0 && (
                            <Button
                                label={`Change Status (${selectedRows.length})`}
                                icon="pi pi-list"
                                className="p-button-warning p-button-sm"
                                onClick={() => {
                                    setBulkStatusEff(new Date());
                                    setBulkStatusDialog(true);
                                }}
                            />
                        )}
                        {active === 'application_setting' && selectedRows.length > 0 && (
                            <Button
                                label={`Change Access (${selectedRows.length})`}
                                icon="pi pi-lock-open"
                                className="p-button-help p-button-sm"
                                onClick={() => {
                                    setBulkAccessEff(new Date());
                                    setBulkAccessDialog(true);
                                }}
                            />
                        )}
                    </div>
                    <div className="flex flex-wrap gap-2 align-items-center">
                        <span className="p-input-icon-left" style={{ minWidth: '220px' }}>
                            <i className="pi pi-search" />
                            <InputText
                                value={globalFilterValue}
                                onChange={(e) => {
                                    setGlobalFilterValue(e.target.value);
                                    setFilters({ global: { value: e.target.value, matchMode: FilterMatchMode.CONTAINS } });
                                }}
                                placeholder={`Search ${cfg.label}...`}
                                className="w-full"
                            />
                        </span>
                        {active !== 'application_setting' && <Button label="Add New" icon="pi pi-plus" className="p-button-primary" onClick={openAdd} />}
                    </div>
                </div>

                {loading ? (
                    <div className="flex justify-content-center align-items-center" style={{ minHeight: '300px' }}>
                        <ProgressSpinner />
                    </div>
                ) : (
                    <>
                        <DataTable
                            value={cfg.hasCellEdit ? editedRows : filteredData}
                            filters={filters}
                            paginator
                            rows={10}
                            rowsPerPageOptions={[10, 25, 50]}
                            paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                            showGridlines
                            tableStyle={{ minWidth: '40rem' }}
                            className="p-datatable-sm"
                            emptyMessage={`No ${statusFilter ? statusFilter.toLowerCase() + ' ' : ''}${cfg.label.toLowerCase()} records found`}
                            selection={cfg.hasRowSelection ? selectedRows : undefined}
                            onSelectionChange={cfg.hasRowSelection ? (e) => setSelectedRows(e.value) : undefined}
                            editMode={cfg.hasCellEdit ? 'cell' : undefined}
                        >
                            {cfg.hasRowSelection && <Column selectionMode="multiple" headerStyle={{ width: '3rem' }} />}
                            {cfg.visibleCols.map((key) => {
                                const editable = cfg.hasCellEdit && CELL_EDITABLE_KEYS.includes(key);
                                return <Column key={`${active}_${key}`} field={key} header={colHeader(key)} sortable body={(rd) => renderCell(key, rd)} {...(editable ? { editor: (opts) => cellEditor(key, opts), onCellEditComplete } : {})} />;
                            })}
                            <Column header="Actions" body={actionBodyTemplate} style={{ width: cfg.hasSmsTest ? '110px' : '90px', textAlign: 'center' }} />
                        </DataTable>

                        {hasAppSettingChanges && (
                            <div className="mt-3 flex justify-content-end">
                                <Button label="Save All Changes" icon="pi pi-check" className="p-button-success" onClick={handleSaveAllSettings} />
                            </div>
                        )}
                    </>
                )}
            </Card>

            {/* Bulk Status Change Dialog */}
            <Dialog
                visible={bulkStatusDialog}
                onHide={() => {
                    setBulkStatusDialog(false);
                    setBulkStatusValue(null);
                    setBulkStatusEff(new Date());
                }}
                header={`Change Status — ${selectedRows.length} Record(s) Selected`}
                style={{ width: '380px' }}
                modal
                draggable={false}
                resizable={false}
                footer={
                    <div className="dialog-footer">
                        <Button
                            label="Cancel"
                            icon="pi pi-times"
                            className="p-button-text p-button-secondary cancel-btn"
                            onClick={() => {
                                setBulkStatusDialog(false);
                                setBulkStatusValue(null);
                                setBulkStatusEff(new Date());
                            }}
                        />
                        <Button label="Update" icon="pi pi-check" className="p-button-raised save-btn" onClick={handleBulkStatusChange} disabled={!bulkStatusValue || !bulkStatusEff} />
                    </div>
                }
            >
                <div className="dialog-content">
                    <div className="field-group">
                        <label className="field-label">
                            New Status <span className="required-mark">*</span>
                        </label>
                        <Dropdown value={bulkStatusValue} options={STATUS_OPTIONS} onChange={(e) => setBulkStatusValue(e.value)} placeholder="Select Status" className="w-full" />
                    </div>
                    <div className="field-group">
                        <label className="field-label">
                            Effective From <span className="required-mark">*</span>
                        </label>
                        <Calendar value={bulkStatusEff} onChange={(e) => setBulkStatusEff(e.value)} dateFormat="dd-mm-yy" placeholder="DD-MM-YYYY" className="w-full" showIcon />
                    </div>
                </div>
            </Dialog>

            {/* Bulk Setting Access Change Dialog */}
            <Dialog
                visible={bulkAccessDialog}
                onHide={() => {
                    setBulkAccessDialog(false);
                    setBulkAccessValue(null);
                    setBulkAccessEff(new Date());
                }}
                header={`Change Setting Access — ${selectedRows.length} Record(s) Selected`}
                style={{ width: '380px' }}
                modal
                draggable={false}
                resizable={false}
                footer={
                    <div className="dialog-footer">
                        <Button
                            label="Cancel"
                            icon="pi pi-times"
                            className="p-button-text p-button-secondary cancel-btn"
                            onClick={() => {
                                setBulkAccessDialog(false);
                                setBulkAccessValue(null);
                                setBulkAccessEff(new Date());
                            }}
                        />
                        <Button label="Update" icon="pi pi-check" className="p-button-raised save-btn" onClick={handleBulkAccessChange} disabled={bulkAccessValue === null || bulkAccessValue === undefined || !bulkAccessEff} />
                    </div>
                }
            >
                <div className="dialog-content">
                    <div className="field-group">
                        <label className="field-label">
                            New Setting Access <span className="required-mark">*</span>
                        </label>
                        <Dropdown value={bulkAccessValue} options={ACCESS_OPTIONS} onChange={(e) => setBulkAccessValue(e.value)} placeholder="Select Access" className="w-full" />
                    </div>
                    <div className="field-group">
                        <label className="field-label">
                            Effective From <span className="required-mark">*</span>
                        </label>
                        <Calendar value={bulkAccessEff} onChange={(e) => setBulkAccessEff(e.value)} dateFormat="dd-mm-yy" placeholder="DD-MM-YYYY" className="w-full" showIcon />
                    </div>
                </div>
            </Dialog>

            {/* SMS Test Dialog */}
            <Dialog
                visible={smsTestDialog}
                onHide={() => setSmsTestDialog(false)}
                header={
                    <div className="dialog-header-custom">
                        <i className="pi pi-send header-icon"></i>
                        <span>Test SMS</span>
                    </div>
                }
                style={{ width: '420px' }}
                modal
                draggable={false}
                resizable={false}
                className="category-dialog"
                footer={
                    <div className="dialog-footer">
                        <Button label="Cancel" icon="pi pi-times" className="p-button-text p-button-secondary cancel-btn" onClick={() => setSmsTestDialog(false)} />
                        <Button label="Send Test SMS" icon="pi pi-send" className="p-button-raised save-btn" onClick={handleSmsTest} loading={smsTestLoading} />
                    </div>
                }
            >
                <div className="dialog-content">
                    <div className="field-group">
                        <label className="field-label">
                            Test Mobile Number <span className="required-mark">*</span>
                        </label>
                        <InputText value={smsTestForm.mobile} onChange={(e) => setSmsTestForm((p) => ({ ...p, mobile: e.target.value }))} placeholder="Enter mobile number" className="w-full" />
                    </div>
                </div>
            </Dialog>

            {/* Add / Edit Dialog */}
            <Dialog
                visible={visible}
                onHide={() => {
                    setVisible(false);
                    setFormData({});
                    setErrors({});
                }}
                header={
                    <div className="dialog-header-custom">
                        <i className={`${cfg.icon} header-icon`}></i>
                        <span>{isEditing ? `Edit ${cfg.label}` : `Add ${cfg.label}`}</span>
                    </div>
                }
                style={{ width: dialogWidth, maxWidth: '95vw' }}
                modal
                className="category-dialog"
                draggable={false}
                resizable={false}
                footer={
                    <div className="dialog-footer">
                        <Button
                            label="Cancel"
                            icon="pi pi-times"
                            className="p-button-text p-button-secondary cancel-btn"
                            onClick={() => {
                                setVisible(false);
                                setFormData({});
                                setErrors({});
                            }}
                        />
                        <Button label={isEditing ? 'Update' : 'Save'} icon="pi pi-check" className="p-button-raised save-btn" onClick={confirmSave} />
                    </div>
                }
            >
                {isSmsModule ? (
                    <div className="dialog-content formgrid grid">
                        {cfg.formFields.map((f) => (
                            <div key={f.key} className="field col-12 md:col-6">
                                {renderField(f, formData, setFormData, errors)}
                            </div>
                        ))}
                    </div>
                ) : (
                    <div className="dialog-content">{cfg.formFields.map((f) => renderField(f, formData, setFormData, errors))}</div>
                )}
            </Dialog>
        </>
    );
};

export default Submasters;
